
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "assess",
})

export default class assess extends Vue {
	
  private tableData: Array<any> = [];
  private commentList: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
	let pageNum = 1;
	let pageSize = 10;
    let paramter = {
		pageNum,
		pageSize
    };
    this.$http.get("producteval/list", {paramter}).then((res: any) => {
    	datas = res.data.data.data;
		let code = res.data.code;
		console.log('res:',res);
		if(code == 200) {
			
			this.tableData = datas;
			for (var i = 0; i < this.tableData.length; i++) {
				
				this.ha(this.tableData[i].id);
			}
			
		}
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }
  private ha(value) {
	  
	  let valueId = value;
	  let pageNum = 1;
	  let pageSize = 10;
	  let productEvalId = valueId;
	  let assessParentId = 0;
	  let paramter = {
	  	pageNum,
	  	pageSize,
	  	productEvalId,
	  	assessParentId
	  };
	  this.$http.get("producteval/assess/manage/list",{params:paramter}).then((res:any)=>{
	  	
	  	let code = res.data.code;
	  	if(code == 200) {
	  		this.commentList = res.data.data.data;
	  		this.commentList = this.commentList.filter(t => t.delTag == 0);
	  		this.commentList = this.commentList.map(item=>{
	  		   if(item.answerCount != 0) {
	  			   item.hasChildren = true;
	  		   }
	  		   return item;
	  		});
	  		console.log('iiiii',this.commentList)
	  	}
	  });
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private handlePublishStatusChange(index,row){
    console.log(row);
  }
  private handleCommentDetail(index,row){
		
		console.log(row);
	  // this.$router.push({path: '/Assess/comment',query:row})
  }
  private onSubmit() {
    console.log(this.form);
  }
}
